export default "__VITE_ASSET__Bk6q4Sk9__"